import React from "react";
import ReactDOM from "react-dom";
import { ConfigProvider } from "antd";
import App from "./App";
import store from "./store/reduxStore";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { antdTheme } from "theme/antdTheme";

// Static message.* and Modal.confirm render outside this tree, so they get the theme through here.
ConfigProvider.config({
    holderRender: (children) => <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>,
});

ReactDOM.render(
    <ConfigProvider theme={antdTheme}>
        <Provider store={store}>
            <App />
        </Provider>
    </ConfigProvider>,
    document.getElementById("root"),
);

serviceWorker.unregister();
